<script>
export default {
  name: 'BitrixTransportersForm',
  render: function(createElement) {
    const formScript = createElement(
      'script',
      {
        attrs: {
          // id : 'bx24_form_inline2',
          'data-b24-form': 'inline/16/ocr59r',
          'data-skip-moving': true,
        },
      },
      `(function(w,d,u){
                var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
                var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
        })(window,document,'https://cdn.bitrix24.ru/b937185/crm/form/loader_16.js');`
    )
    return formScript
  },
}
</script>
<style></style>
